/**
 * @generated SignedSource<<54f4d0a8c114f36feaa7ce49a33fa1f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerContentBookmarkArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "headerContentBookmarkArticle";
};
export type headerContentBookmarkArticle$key = {
  readonly " $data"?: headerContentBookmarkArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerContentBookmarkArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "headerContentBookmarkArticle"
};

(node as any).hash = "2683872e652fb4471930705e868be293";

export default node;
